import React from 'react'
import OppBriefSection from "./OppBriefSection";

export default class OppBriefClientProjectOverviewSection extends OppBriefSection {

    static sectionTitle = 'Client and Project Overview';

    static TranslationKey = '';

    static CompletedField = 'accepted_client_project_overview_at';

    constructor(props) {
        super(props);

        this.state = {
            ...this.state
        }
    }

    render() {
        let {opportunity} = this.props;
        let {project} = opportunity;

        let client = opportunity.client || project.client;
        return (
            <div className="project-brief-section">
                <div className="deliverable-category-container client-project-overview">
                    {client && (
                        <div className="deliverable-panel">
                            <p className={TB.mapClass("deliverable-title", {
                                'opp-unseen-update': opportunity.hasUnseenUpdateToProjectClient()
                            })}>
                                Client Name and Industry
                            </p>
                            <div className="deliverable-details-panel flex deliverable-client-overview">
                                <div className="deliverable-section">
                                    <p className={TB.mapClass("deliverable-section-title", {
                                        'opp-unseen-update': (opportunity.hasUnseenUpdateToProjectClientName() || opportunity.hasUnseenUpdateToProjectClientLogo())
                                    })}>
                                        Client
                                    </p>
                                    <div className="deliverable-section-description">
                                        <img src={client.logo_path} alt={client.name}/>

                                        <h4>{client.name}</h4>
                                    </div>
                                </div>
                                {client.industry && (
                                    <div className="deliverable-section">
                                        <p className={TB.mapClass("deliverable-section-title", {
                                            'opp-unseen-update': opportunity.hasUnseenUpdateToProjectClientIndustry()
                                        })}>
                                            Industry
                                        </p>
                                        <div className="deliverable-section-description">
                                            <h4>
                                                {client.industry?.name}
                                            </h4>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {project.location && (
                        <div className="deliverable-panel">
                            <p className={TB.mapClass("deliverable-title", {
                                'opp-unseen-update': opportunity.hasUnseenUpdateToProjectLocation()
                            })}>
                                Project Location
                            </p>
                            <div className="deliverable-details-panel">
                                <div className="deliverable-section">
                                    {project.location.full}
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="deliverable-panel">
                        <p className={TB.mapClass("deliverable-title", {
                            'opp-unseen-update': (opportunity.hasUnseenUpdateToProjectName() || opportunity.hasUnseenUpdateToProjectDescription())
                        })}>
                            Project Summary
                        </p>
                        <div className="deliverable-details-panel summary-details-panel">

                            {project.service && (
                                <div className="deliverable-section">
                                    <p className="deliverable-section-title">
                                        Project Type
                                    </p>
                                    <p className="deliverable-section-description">
                                        {project.service.name}
                                    </p>
                                </div>
                            )}
                            <div className="deliverable-section">
                                <p className={TB.mapClass("deliverable-section-title", {
                                    'opp-unseen-update': opportunity.hasUnseenUpdateToProjectName()
                                })}>
                                    Project name
                                </p>
                                <p className="deliverable-section-description">
                                    {project.name}
                                </p>
                            </div>

                            <div className="deliverable-section">
                                <p className={TB.mapClass("deliverable-section-title", {
                                    'opp-unseen-update': opportunity.hasUnseenUpdateToProjectDescription()
                                })}>
                                    Project Description
                                </p>
                                {project.description ? <div className="rich-text-display mb-3">
                                    <span dangerouslySetInnerHTML={{__html: project.description}}/>
                                </div> : (
                                    <p className="deliverable-section-description">
                                        Not Provided
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}